import { Breadcrumbs } from './Breadcrumbs';
import { useStyles } from './TopBar.styles';

export const TopBar = () => {
    const { classes } = useStyles();

    return (
        <div className={classes.container} automation-id="top-bar">
            <Breadcrumbs />
        </div>
    );
};
